import React from 'react';
import PropTypes from 'prop-types';

function AlignStartHorizontal({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M3.33325 3.33334V16.6667M7.33325 11.3333H10.6666C11.403 11.3333 11.9999 11.9303 11.9999 12.6667V14C11.9999 14.7364 11.403 15.3333 10.6666 15.3333H7.33325C6.59687 15.3333 5.99992 14.7364 5.99992 14V12.6667C5.99992 11.9303 6.59687 11.3333 7.33325 11.3333ZM7.33325 4.66667H15.3333C16.0696 4.66667 16.6666 5.26362 16.6666 6V7.33334C16.6666 8.06972 16.0696 8.66667 15.3333 8.66667H7.33325C6.59687 8.66667 5.99992 8.06972 5.99992 7.33334V6C5.99992 5.26362 6.59687 4.66667 7.33325 4.66667Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

AlignStartHorizontal.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AlignStartHorizontal;
